import { render, staticRenderFns } from "./HomeworkPlan.vue?vue&type=template&id=46f17ef8"
import script from "./HomeworkPlan.vue?vue&type=script&lang=js"
export * from "./HomeworkPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports